module.exports = __webpack_public_path__ + "static/p1-4b9e1f95db4e6ac9e3c53f7d6ff3027c.jpg";